export const PERSONAL_ALLOWANCE = 12570;
export const TAPER_THRESHOLD = 100000;
export const ADDITIONAL_RATE_THRESHOLD = 125140;
export const BASIC_BAND = 37700;
export const BASIC_RATE = 0.2;
export const HIGHER_RATE = 0.4;
export const ADDITIONAL_RATE = 0.45;

export const personalAllowanceForIncome = (adjustedIncome, ignoreTaper = false) => {
  if (ignoreTaper) return PERSONAL_ALLOWANCE;
  if (adjustedIncome <= TAPER_THRESHOLD) return PERSONAL_ALLOWANCE;
  const reduction = (adjustedIncome - TAPER_THRESHOLD) / 2;
  return Math.max(0, PERSONAL_ALLOWANCE - reduction);
};

export const calculateTax = (income, pension = 0, { ignoreTaper = false } = {}) => {
  const pensionContribution = Math.max(pension, 0);
  const adjustedIncome = Math.max(0, income - pensionContribution);
  const personalAllowance = personalAllowanceForIncome(adjustedIncome, ignoreTaper);
  const taxableIncome = Math.max(0, adjustedIncome - personalAllowance);

  const basicTaxable = Math.min(taxableIncome, BASIC_BAND);
  const additionalThresholdTaxable = Math.max(0, ADDITIONAL_RATE_THRESHOLD - personalAllowance);
  const higherBandCap = Math.max(0, additionalThresholdTaxable - BASIC_BAND);
  const higherTaxable = Math.min(Math.max(taxableIncome - BASIC_BAND, 0), higherBandCap);
  const additionalTaxable = Math.max(taxableIncome - BASIC_BAND - higherTaxable, 0);

  const basicTax = basicTaxable * BASIC_RATE;
  const higherTax = higherTaxable * HIGHER_RATE;
  const additionalTax = additionalTaxable * ADDITIONAL_RATE;
  const totalTax = basicTax + higherTax + additionalTax;
  const takeHome = income - totalTax - pensionContribution;
  const effectiveRate = income > 0 ? (totalTax / income) * 100 : 0;

  return {
    adjustedIncome,
    personalAllowance,
    taxableIncome,
    basicTax,
    higherTax,
    additionalTax,
    totalTax,
    takeHome,
    effectiveRate,
  };
};
